import { useState } from 'react';
import { Play, X } from 'lucide-react';
import videoThumbnailImg from '../../../../../assets/video_demo_thumbnail.png';

const SeeItWorkingCard = () => {
  const [isPlayingInline, setIsPlayingInline] = useState(false);

  return (
    <div
      data-tour="video"
      className="lg:col-span-7 xl:col-span-7 bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-7 xl:p-8 border border-slate-100 shadow-sm flex flex-col hover:shadow-md transition-all duration-300"
    >
      <div>
        <h3 className="text-lg sm:text-xl font-normal text-slate-800 tracking-tight leading-snug">
          See it working
        </h3>
        <p className="text-xs sm:text-sm text-slate-500 mt-1 font-normal leading-relaxed">
          Voucher creation, the traveller app, live location and notifications.
        </p>
      </div>

      {/* Video Preview / Player Area */}
      <div className="mt-3.5 sm:mt-4 relative rounded-2xl sm:rounded-3xl overflow-hidden aspect-video border border-slate-200/80 shadow-sm bg-slate-900 w-full">
        {isPlayingInline ? (
          <div className="relative w-full h-full bg-black flex items-center justify-center">
            <video
              src="https://trrip-prod-storage.s3.ap-south-1.amazonaws.com/assets/trrip_platform_demo.mp4?v=4k"
              controls
              autoPlay
              playsInline
              className="w-full h-full rounded-2xl sm:rounded-3xl object-contain bg-black"
            />
            <button
              onClick={() => setIsPlayingInline(false)}
              className="absolute top-3 right-3 z-20 p-1.5 rounded-full bg-slate-900/80 hover:bg-slate-900 text-white/90 hover:text-white transition-all shadow-md backdrop-blur-xs cursor-pointer"
              title="Close Video"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        ) : (
          <div
            onClick={() => setIsPlayingInline(true)}
            className="w-full h-full relative cursor-pointer group overflow-hidden bg-slate-50"
          >
            {/* Full-bleed Clean Thumbnail */}
            <img
              src={videoThumbnailImg}
              alt="Trrip Platform Demo"
              className="w-full h-full object-cover object-center group-hover:scale-[1.02] transition-transform duration-300 select-none"
            />

            {/* Ambient Center Glow */}
            <div className="absolute inset-0 bg-radial from-transparent via-black/20 to-black/50 pointer-events-none" />

            {/* Center Play Button Overlay */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-primary/95 text-white flex items-center justify-center shadow-lg shadow-primary/30 group-hover:scale-110 group-hover:bg-primary transition-all duration-200">
                <Play className="w-5 h-5 sm:w-6 sm:h-6 fill-white ml-0.5" />
              </div>
            </div>

            {/* Bottom Video Runtime Pill */}
            <div className="absolute bottom-2.5 right-2.5 sm:bottom-4 sm:right-4 z-10 px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-lg bg-slate-900/80 backdrop-blur-md text-white text-[10px] sm:text-[11px] font-medium tracking-wide shadow-md">
              8:50
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SeeItWorkingCard;
